import $ from 'jquery';
import Backbone from 'backbone';
import _ from 'underscore';
import ObjectUtil from '@component/common/src/util/ObjectUtil';
import ServiceUrl from '../util/ServiceUrl';

const QBModel = Backbone.Model.extend({
  idAttribute: 'bagItemId',
  urlRoot() {
    return `${ServiceUrl.getUrl()}/items/`;
  },
  productConfig: {
    productImage: {
      primaryImage: {
        alt: '',
        width: '75',
        height: '75',
        quality: '90',
      },
    },
    swatchImage: {
      primaryImage: {
        alt: '',
        width: '19',
        height: '19',
        quality: '90',
      },
    },
  },

  // ###Method - productImageGenerator()  updates the product image url to the correct path
  // > parameters
  // >
  // + *imageryObj* - ImageryObject from the response
  // > returns
  // >
  // + A product image url modified imagery object
  productImageGenerator(imageryObj) {
    const clonedImageryObj = $.extend(true, {}, imageryObj);
    const config = $.extend(true, {}, this.productConfig.productImage.primaryImage, imageryObj.primaryImage);
    let tempProductImageUrl;

    tempProductImageUrl = clonedImageryObj.urlTemplate.product.replace(/\[QUALITY\]/gi, config.quality);
    tempProductImageUrl = tempProductImageUrl.replace(/\[WIDTH\]/gi, config.width);
    tempProductImageUrl = tempProductImageUrl.replace(/\[IMAGEFILEPATH\]/gi, config.filePath);

    clonedImageryObj.urlTemplate.product = tempProductImageUrl;

    return clonedImageryObj;
  },

  // ###Method - productSwatchGenerator()  updates the swatch image url to the correct path
  // > parameters
  // >
  // + *imageryObj* - ImageryObject from the response
  // > returns
  // >
  // + A swatch image url modified imagery object
  productSwatchGenerator(imageryObj) {
    const clonedImageryObj = $.extend(true, {}, imageryObj);
    const config = $.extend(true, {}, this.productConfig.swatchImage.primaryImage, imageryObj.selectedColor.swatchImage);
    let tempSwatchImageUrl;

    tempSwatchImageUrl = clonedImageryObj.urlTemplate.swatch.replace(/\[WIDTH\]/gi, config.width);
    tempSwatchImageUrl = tempSwatchImageUrl.replace(/\[HEIGHT\]/gi, config.quality);
    tempSwatchImageUrl = tempSwatchImageUrl.replace(/\[IMAGEFILEPATH\]/gi, config.filePath);

    clonedImageryObj.selectedColor.swatchImage.imageFullPath = tempSwatchImageUrl;

    return clonedImageryObj;
  },

  setCustomHeaders(xhr) {
    const product = this.get('product');
    const gwpIndicator = ObjectUtil.getChildProperty(product, 'detail.flags.gwpIndicator') || false;
    xhr.setRequestHeader('Gwp-Header', gwpIndicator);
  },

  destroy(options) {
    const extendedOtions = $.extend(options, {
      beforeSend: this.setCustomHeaders.bind(this),
    });
    Backbone.Model.prototype.destroy.call(this, extendedOtions);
  },
  // ###Method - parse()  updates the price, source image url and swatch image url
  // > parameters
  // >
  // + *attrs* - model attributes
  // > returns
  // >
  // + A massaged model attributes
  parse(_attrs) {
    const attrs = _attrs;
    /* istanbul ignore else */
    if (ObjectUtil.hasChildProperty(attrs, 'product.pricing.price.tieredPrice')) {
      attrs.product.pricing.price.tieredPrice = _.map(attrs.product.pricing.price.tieredPrice, (_price) => {
        const price = _price;
        price.label = price
          .label
          .replace(/\[PRICE\]/g, () => `<span>${price.formattedValue[0]}</span>`)
          .replace(':', '');
        return price;
      });
    }

    /* istanbul ignore else */
    if (ObjectUtil.hasChildProperty(attrs, 'product.imagery.urlTemplate.product')) {
      attrs.product.imagery = this.productImageGenerator(attrs.product.imagery);
    }
    /* istanbul ignore else */
    if (ObjectUtil.hasChildProperty(attrs, 'product.traits.colors.selectedColor.swatchImage')) {
      attrs.product.traits.colors = this.productSwatchGenerator(attrs.product.traits.colors);
    }

    return attrs;
  },
});

export default QBModel;
